import { useAuthContext } from "providers/Auth";
import { FEATURES } from "types/landlord/partner";

export const useBoomHelpEnabled = () => {
  const { partner } = useAuthContext();
  return Boolean(partner?.features.includes(FEATURES.UI_BOOM_HELP));
};
